.page {
  width: 100%;
}

/* Layout of the DS Header (title style comes from the design system). */
.header {
  height: auto;
  margin-bottom: 22px;
  align-items: flex-start;

  /* actions right-aligned, 8px gap */
  [class*="module_actions"] {
    align-self: flex-start;
    gap: var(--spacing-2);
  }
}

/* description sits 6px under the title, then the 22px block gap follows */
.header + .description {
  margin-top: -16px;
}

.description {
  margin-bottom: 22px;
  max-width: 680px;
  color: var(--color-grey);
  font-size: var(--font-size-m);
  line-height: 1.5;
}
